export function fetchAssetIdFromSherbertUrl(assetUrl) {
    if (!assetUrl)
        return '';
    return assetUrl.split('/assets/')[1].split('/')[0];
}
export var ImageFormat;
(function (ImageFormat) {
    ImageFormat["Bmp"] = "bmp";
    ImageFormat["Jpeg"] = "jpeg";
    ImageFormat["Mvg"] = "mvg";
    ImageFormat["Png"] = "png";
    ImageFormat["Svg"] = "svg";
    ImageFormat["Svgxml"] = "svg+xml";
    ImageFormat["Tga"] = "tga";
    ImageFormat["Tiff"] = "tiff";
    ImageFormat["Webp"] = "webp";
    ImageFormat["Ai"] = "ai";
    ImageFormat["Eps"] = "eps";
    ImageFormat["Pdf"] = "pdf";
    ImageFormat["Ppt"] = "ppt";
    ImageFormat["Unknown"] = "unknown";
})(ImageFormat || (ImageFormat = {}));
// Checks if the file is a Raster Image supported by Sherbert
export function isRaster(file) {
    if (file.type.includes(ImageFormat.Bmp) ||
        file.type.includes(ImageFormat.Jpeg) ||
        file.type.includes(ImageFormat.Png) ||
        file.type.includes(ImageFormat.Tga) ||
        file.type.includes(ImageFormat.Tiff) ||
        file.type.includes(ImageFormat.Webp))
        return true;
    return false;
}
// This function provides ImageFormat of Raster Images supported by Sherbert
export function getImageFormat(type) {
    if (type.includes(ImageFormat.Jpeg))
        return ImageFormat.Jpeg;
    if (type.includes(ImageFormat.Png))
        return ImageFormat.Png;
    if (type.includes(ImageFormat.Bmp))
        return ImageFormat.Bmp;
    if (type.includes(ImageFormat.Tga))
        return ImageFormat.Tga;
    if (type.includes(ImageFormat.Tiff))
        return ImageFormat.Tiff;
    if (type.includes(ImageFormat.Webp))
        return ImageFormat.Webp;
    return ImageFormat.Unknown;
}
export var VariantTypes;
(function (VariantTypes) {
    VariantTypes["Original"] = "original";
    VariantTypes["Print"] = "print";
    VariantTypes["WebPreview"] = "webPreview";
    VariantTypes["Thumb"] = "thumb";
    VariantTypes["BackgroundRemoved"] = "backgroundRemoved";
    VariantTypes["Sharpened"] = "sharpened";
    VariantTypes["Embroidery"] = "embroidery";
    VariantTypes["Monochrome"] = "monochrome";
    VariantTypes["Embroiderify"] = "embroiderify";
    VariantTypes["InvertColor"] = "invertColor";
})(VariantTypes || (VariantTypes = {}));
export var Route;
(function (Route) {
    Route["V2"] = "v2";
    Route["V3"] = "v3";
})(Route || (Route = {}));
export var ImageFormatSchemaEnum;
(function (ImageFormatSchemaEnum) {
    ImageFormatSchemaEnum["Pdf"] = "pdf";
    ImageFormatSchemaEnum["Ppt"] = "ppt";
})(ImageFormatSchemaEnum || (ImageFormatSchemaEnum = {}));
/** checks if format exists in ImageFormatSchemaEnum
 * @param {string} format takes format string
 * @returns {boolean} returns true if format is in ImageFormatSchemaEnum otherwise false
 */
export function isAllowedFormat(format) {
    const imageFormatSchemaArray = Object.values(ImageFormatSchemaEnum);
    return imageFormatSchemaArray.includes(format);
}
export function isRoute(route) {
    return route === Route.V2 || route === Route.V3;
}
export function isDocumentItem(options) {
    var _a, _b;
    return (((_a = options.parentAsset.uploadOptions) === null || _a === void 0 ? void 0 : _a.type) === 'documentItem' || ((_b = options.parentAsset._data) === null || _b === void 0 ? void 0 : _b.type) === 'documentItem');
}
export function isJsonFile(file) {
    if (!file.name.endsWith('.json')) {
        return false;
    }
    return true;
}
export function isJsonUrl(url) {
    // Regular expression to match common JSON file extensions
    const jsonFileExtensions = ['json'];
    // Split the URL by '/'
    const parts = url.split('/');
    // Check if any part of the URL matches a JSON file extension
    for (const part of parts) {
        const extension = part.split('.').pop() || ''; // Get the file extension
        if (jsonFileExtensions.includes(extension.toLowerCase())) {
            return true;
        }
    }
    // If none of the parts match a JSON file extension, return false
    return false;
}
//# sourceMappingURL=utility.js.map